module.exports = __webpack_public_path__ + "static/resume-30e17adf8723b448e9d82835896028eb.gif";